// extracted by mini-css-extract-plugin
module.exports = {"Featured":"Portfolio_Featured_Featured__O__69","Image":"Portfolio_Featured_Image__D4m7V","Summary":"Portfolio_Featured_Summary__nk4WH","Logo":"Portfolio_Featured_Logo__KYTIq"};